<template>
  <form>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Nom et Postnom</span>
      </div>
      <input :value="joueur.nom"
             name="joueur_nom"
             disabled
             type="text"
             class="form-control">
      <input :value="joueur.postnom"
             name="joueur_postnom"
             disabled
             type="text"
             class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <span class="input-group-text">Prénom</span>
      </div>
      <input :value="joueur.prenom"
             name="joueur_prenom"
             disabled
             type="text"
             class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <span class="input-group-text">Poste</span>
      </div>
      <input :value="joueur.poste"
             name="joueur_poste"
             disabled
             type="number"
             class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <span class="input-group-text">Taille</span>
      </div>
      <input :value="joueur.taille"
             name="joueur_taille"
             disabled
             type="text"
             class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <span class="input-group-text">Poids</span>
      </div>
      <input :value="joueur.poids"
             name="joueur_poids"
             disabled
             type="text"
             class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <span class="input-group-text">Date de naissance et Age</span>
      </div>
      <input :value="joueur.date_naissance"
             name="joueur_date_naissance"
             disabled
             type="date"
             class="form-control">
      <input :value="joueur.age + ' ans'"
             name="joueur_age"
             disabled
             type="text"
             class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <span class="input-group-text">Dossard</span>
      </div>
      <input :value="joueur.dossard"
             name="joueur_dossard"
             disabled
             type="text"
             class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Nationalité</label>
      </div>
      <select name="joueur_nationalite"
              disabled
              class="custom-select">
        <option>{{ joueur.nationalite }}</option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Equipe</label>
      </div>
      <select name="joueur_equipe"
              disabled
              class="custom-select">
        <option>{{ (equipe && equipe.nom) ? equipe.nom : '' }}</option>
</select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Date début et fin du contrat</span>
      </div>
      <input :value="joueur.date_debut_contrat"
             name="joueur_date_debut_contrat"
             disabled
             type="text"
             class="form-control">
      <input :value="joueur.date_fin_contrat"
             name="joueur_"
             disabled
             type="text"
             class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <span class="input-group-text">Commentaires</span>
      </div>
      <textarea :value="joueur.commentaires"
                name="joueur_commentaires"
                disabled
                class="form-control">
      </textarea>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Telephones</span>
      </div>
      <input :value="joueur.telephones"
             name="joueur_telephone_1"
             disabled
             type="text"
             class="form-control">
      <input :value="joueur.telephones"
             name="joueur_telephone_2"
             disabled
             type="text"
             class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Email</span>
      </div>
      <input :value="joueur.email"
             name="joueur_email"
             disabled
             type="email"
             class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Surnom</span>
      </div>
      <input :value="joueur.surnom"
             name="joueur_surnom"
             disabled
             type="text"
             class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Type des contrats</label>
      </div>
      <select name="joueur_type_contrat"
              disabled
              class="custom-select">
        <option>{{ joueur.type_contrat }}</option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="mr-3">Selectionné ? </div>
      <div class="form-check form-check-inline">
        <input class="form-check-input"
               type="radio" disabled
               name="joueur_selectionne"
               value="oui"
               :checked="(joueur.selectionne === 'oui') ? true : false ">
        <label class="form-check-label rounded pl-2 pr-2">OUI</label>
      </div>
      <div class="form-check form-check-inline">
        <input class="form-check-input"
               type="radio" disabled
               name="joueur_selectionne"
               value="non"
               :checked="(joueur.selectionne === 'non') ? true : false ">
        <label class="form-check-label rounded pl-2 pr-2">NON</label>
      </div>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Date et Temps de creation</span>
      </div>
      <input :value="joueur.date_creation"
             name="joueur_date_creation"
             disabled
             type="date"
             class="form-control">
      <input :value="joueur.temps_creation"
             name="joueur_temps_creation"
             disabled
             type="time"
             class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Date et Temps de mise à jour</span>
      </div>
      <input :value="joueur.date_modification"
             name="joueur_date_modification"
             disabled
             type="date"
             class="form-control">
      <input :value="joueur.temps_modification"
             name="joueur_temps_modification"
             disabled
             type="time"
             class="form-control">
    </div>
  </form>
</template>

<script>
import {mapMutations, mapActions, mapGetters} from 'vuex'

export default {
  name: "Read",
  props: {
    joueur: {
      type: Object
    }
  },
  data(){
    return{
      equipe: null
    }
  },
  components: {},
  methods: {
    ...mapMutations([]),
    ...mapActions([
      'axiosGetOneData'
    ]),
  },
  computed: {
    ...mapGetters([])
  },
  beforeCreate() {},
  created() {
    //
    this.axiosGetOneData({
      table: "equipes",
      table_id: this.joueur.equipe_id
    })
        .then( (data) => {
          this.equipe = data.data
        })
        .catch( (error) => {

        })
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {}
}
</script>

<style lang="scss" scoped>
form{
  & > div{
    & > div{
      & > span, & > label{
        background-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
        color: var(--color-white, rgba(255, 255, 255, 1));
        border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
      }
      & > span.customized-span{
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
        line-height: 1.5;
        border-radius: 0.2rem;
      }
    }
    & > input, & > select{
      border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/joueurs/components/Read.vue